{
  "preview.answer.device.desktop": "Desktop",
  "preview.answer.device.mobile": "Mobile",
  "preview.answer.device.tablet": "Tablet",
  "preview.answer.deviceLabel": "Device",
  "preview.answer.envOff": "{name} is switched off on {env}. Its address shows nothing.",
  "preview.answer.envs": "Environment",
  "preview.answer.frameTitle": "Preview of {name}",
  "preview.answer.inspect": "Inspect elements",
  "preview.answer.inspectFailed": "{name} could not open for inspection.",
  "preview.answer.inspectFrameTitle": "Inspect {name}",
  "preview.answer.inspectLoading": "Opening {name} for inspection…",
  "preview.answer.inspectReady": "Inspect is on. Pick an element to ask about it.",
  "preview.answer.loading": "Loading {name}…",
  "preview.answer.loadingPart": "Loading…",
  "preview.answer.missing": "No website in this workspace matches.",
  "preview.answer.neverPublished": "{name} was never published on {env}. Its address shows the latest saved version.",
  "preview.answer.noContent": "{name} has no pages on {env} yet.",
  "preview.answer.none": "This workspace has no website to preview yet.",
  "preview.answer.notWebsite": "{name} is not a website. This card shows websites.",
  "preview.answer.open": "Open the site in a new tab",
  "preview.answer.openInPreview": "Open in Preview",
  "preview.answer.page": "Page",
  "preview.answer.pick": "Pick an element",
  "preview.answer.picking": "Click an element of the page. Esc stops.",
  "preview.answer.reload": "Reload",
  "preview.answer.slow": "{name} is still loading. The site is slow to answer.",
  "preview.answer.storeApp": "{name} is an app from the App Store, not a project of this workspace. This card shows websites.",
  "preview.answer.title": "Website",
  "preview.assistant.close": "Close assistant",
  "preview.assistant.requestFailed": "Sorry — that request failed ({message}).",
  "preview.assistant.transportNotReady": "Assistant transport not ready — please retry in a moment.",
  "preview.builder.draft": "Draft · not published",
  "preview.builder.page": "Page",
  "preview.builder.publish": "Publish",
  "preview.builder.setup": "Setting up your site…",
  "preview.builder.updating": "Updating preview…",
  "preview.builder.working": "Working on the site…",
  "preview.dsView.empty": "{name} has no design system yet.",
  "preview.dsView.failed": "The design system of {name} could not be shown.",
  "preview.dsView.frameTitle": "Design system of {name}",
  "preview.dsView.section": "Section",
  "preview.dsView.title": "Design system",
  "preview.envBanner.fallback": "Showing {resolved} env — {requested} not published yet.",
  "preview.errorBoundary.code.unknown": "Unknown error",
  "preview.errorBoundary.openInEditor": "Open in editor",
  "preview.errorBoundary.openInSymbols": "Open in Symbols",
  "preview.errorBoundary.password.failed": "Failed to unlock.",
  "preview.errorBoundary.password.incorrect": "Incorrect password. Try again.",
  "preview.errorBoundary.password.label": "Password",
  "preview.errorBoundary.password.placeholder": "Enter project password",
  "preview.errorBoundary.password.required": "Password is required.",
  "preview.errorBoundary.password.unlock": "Unlock",
  "preview.errorBoundary.password.unlocking": "Unlocking…",
  "preview.errorBoundary.retry.busy": "Retrying…",
  "preview.errorBoundary.retry.idle": "Retry",
  "preview.errorBoundary.subtitle.bootFailed": "Could not create {slug}{env}. The published snapshot has a malformed design system or page.",
  "preview.errorBoundary.subtitle.noData": "Unable to load project data.",
  "preview.errorBoundary.subtitle.notAvailable": "{slug} isn't shared publicly. If you have access, open it in Symbols.",
  "preview.errorBoundary.subtitle.passwordRequired": "{slug} is password-protected. Enter the password to view.",
  "preview.errorBoundary.subtitle.thisProject": "this project",
  "preview.errorBoundary.subtitle.unexpected": "An unexpected error occurred.",
  "preview.errorBoundary.title.bootFailed": "Preview failed to start",
  "preview.errorBoundary.title.loadFailed": "Preview failed to load",
  "preview.errorBoundary.title.notAvailable": "Project not available",
  "preview.errorBoundary.title.passwordRequired": "Password required",
  "preview.errorBoundary.title.unavailable": "Preview unavailable",
  "preview.errorBoundary.triedEnvs.label": "Tried:",
  "preview.navbar.a11yFilter": "Accessibility simulation",
  "preview.navbar.assistantHide": "Hide AI assistant",
  "preview.navbar.assistantShow": "Ask the AI assistant",
  "preview.navbar.canvasLink": "Open in Canvas editor",
  "preview.navbar.device.mobileXS": "Mobile (375×768)",
  "preview.navbar.device.resizable": "Resizable",
  "preview.navbar.device.screenL": "Large Screen (1920×1024)",
  "preview.navbar.device.screenM": "Medium Screen (1680×1024)",
  "preview.navbar.device.tabletL": "Tablet Landscape (1366×926)",
  "preview.navbar.device.tabletS": "Tablet Portrait (1024×768)",
  "preview.navbar.env.development": "Development",
  "preview.navbar.env.loading": "{env} · loading…",
  "preview.navbar.env.production": "Production",
  "preview.navbar.env.staging": "Staging",
  "preview.navbar.openInNewTab": "Open in new tab",
  "preview.navbar.refresh": "Refresh preview",
  "preview.navbar.settings": "Settings",
  "preview.navbar.settingsPanel.showInherited": "Show inherited from shared libraries",
  "preview.navbar.settingsPanel.showInheritedHint": "Includes pages and components contributed by linked shared libraries.",
  "preview.navbar.settingsPanel.title": "Display options",
  "preview.navbar.sidebarHide": "Hide sidebar",
  "preview.navbar.sidebarShow": "Show sidebar",
  "preview.navbar.theme.dark": "Dark mode",
  "preview.navbar.theme.light": "Light mode",
  "preview.navbar.urlCopied": "Copied",
  "preview.pagesView.back": "Back to all",
  "preview.pagesView.componentFailed": "{name} could not be shown.",
  "preview.pagesView.more": "{n} of {total}",
  "preview.pagesView.noComponents": "{name} has no components yet.",
  "preview.pagesView.noPages": "{name} has no pages yet.",
  "preview.pagesView.openTile": "Open {name} live",
  "preview.pagesView.show": "Show",
  "preview.pagesView.title": "Website pages",
  "preview.pagesView.unread": "The pages of {name} could not be read.",
  "preview.sceneNavbar.fullscreen": "Fullscreen",
  "preview.sceneNavbar.minimize": "Minimize",
  "preview.sidebar.category.components": "Components",
  "preview.sidebar.category.designSystem": "Design System",
  "preview.sidebar.category.pages": "Pages",
  "preview.sidebar.ds.colors": "Colors",
  "preview.sidebar.ds.icons": "Icons",
  "preview.sidebar.ds.layout": "Layout",
  "preview.sidebar.ds.misc": "Misc",
  "preview.sidebar.ds.spacing": "Spacing",
  "preview.sidebar.ds.transitions": "Transitions",
  "preview.sidebar.ds.typography": "Typography"
}
